import React from "react";
import Messages from "../../common/Messages";

const StudentMessages: React.FC = () => {
  return <Messages userRole="student" conversationType="ProblemConversation" />;
};

export default StudentMessages;
